// Author yujiabei
// Date 2021-06-28 18:04:55

import * as model from "@/model/em/admin/EmAdmFactoryModelTypeEafmtModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAdmFactoryModelTypeEafmt(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .buildStore()
